import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    handleSelect = (selectedKey) => {
        this.setState({ selectedTab: selectedKey });
    };

    render() {                       

        return (
            <div className={styles.footerDiv}>
                <div className={styles.footerInnerDiv}>
                    <div className={styles.footerFirstLine}>
                        <Link to="/" style={{ display: 'inline-block' }}>
                            <img
                                src="/images/logotipo_branco.svg"
                                width="265"
                                className="d-inline-block align-top"
                                alt="Logo"
                                style={{ cursor: 'pointer' }}
                            />
                        </Link>
                        <div className={styles.socialsDiv}>
                            <span>Acompanhe nas redes:</span>
                            <div style={{ display: 'flex', gap: '12px' }}>
                                {/* <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                                    <img
                                        src="/images/icons/Facebook.svg"
                                        width="40"
                                        alt="Facebook"
                                        className={styles.socialIcon}
                                    />
                                </a>
                                <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
                                    <img
                                        src="/images/icons/Instagram.svg"
                                        width="40"
                                        alt="Instagram"
                                        className={styles.socialIcon}
                                    />
                                </a> */}
                                <a href="https://www.linkedin.com/company/fiscaldata/" target="_blank" rel="noopener noreferrer">
                                    <img
                                        src="/images/icons/LinkedIn.svg"
                                        width="40"
                                        alt="LinkedIn"
                                        className={styles.socialIcon}
                                    />
                                </a>
                                {/* <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
                                    <img
                                        src="/images/icons/X.svg"
                                        width="40"
                                        alt="X"
                                        className={styles.socialIcon}
                                    />
                                </a> */}
                            </div>
                        </div>
                        <div className={styles.footerDoubt}>
                            <span>Dúvidas?</span>
                            <span className={styles.doubtEmail}>contato@fiscaldata.com.br</span>
                        </div>
                        <img
                            src="/images/icons/back_top.svg"
                            width="40"
                            alt="Voltar ao topo"
                            className={styles.socialIcon}
                            style={{ backgroundColor: 'transparent', width: '55px' }}
                            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                        />
                    </div>
                    <hr className={styles.hr} />
                    <div className={styles.footerTermsData}>
                        <span>© 2025 FISCALDATA</span>
                        <div className={styles.footerTerms}>
                            <div
                                style={{
                                    width: '5px',
                                    height: '5px',
                                    backgroundColor: '#24286B',
                                }}
                            />
                            <span>Termos de uso</span>
                            <div
                                style={{
                                    width: '5px',
                                    height: '5px',
                                    backgroundColor: '#24286B',
                                    marginLeft: '20px'
                                }}
                            />
                            <span>Política de privacidade</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;